import { render, staticRenderFns } from "./framework_index.vue?vue&type=template&id=6b2b7046&"
import script from "./framework_index.vue?vue&type=script&lang=js&"
export * from "./framework_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports